import { RootState } from '../../../base';

export const loginSelectors = {
    getIsLoginLoading: (state: RootState) => state.login.uiState.isLoginLoading,
    getIsResetPasswordEmailSent: (state: RootState) =>
        state.login.isResetPasswordEmailSent,
    getIsForgotPasswordLoading: (state: RootState) =>
        state.login.uiState.isForgotPasswordLoading,
    getIsChangePasswordLoading: (state: RootState) =>
        state.login.uiState.isChangePasswordLoading,
    getIsResetPasswordLoading: (state: RootState) =>
        state.login.uiState.isResetPasswordLoading,
    getIsGoogleLoginLoading: (state: RootState) =>
        state.login.uiState.isGoogleLoginLoading,
    getGoogleLoginErrorMessage: (state: RootState) =>
        state.login.googleLoginErrorMessage,
};
